import logo from './logo.svg';
import './App.css';
import Surveypage from './pages/Surveypage';

function App() {
  return (
<Surveypage/>
  );
}

export default App;
